// @ts-nocheck
import * as Types from '@src/types/graphql-types';

import { gql } from '@apollo/client';
import * as React from 'react';
import * as Apollo from '@apollo/client';
import * as ApolloReactComponents from '@apollo/client/react/components';
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
const defaultOptions = {} as const;
export type ContentDocumentSearchQueryVariables = Types.Exact<{
  searchTerm?: Types.InputMaybe<Types.Scalars['String']['input']>;
  page: Types.Scalars['Int']['input'];
  perPage?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  selectedFacets?: Types.InputMaybe<Array<Types.FacetInput> | Types.FacetInput>;
  contentSearchType: Types.ContentSearchType;
  filterSite?: Types.InputMaybe<Types.Scalars['String']['input']>;
}>;


export type ContentDocumentSearchQuery = { __typename?: 'Query', getContentDocuments: { __typename?: 'ContentDocumentSearchResponse', metadata: { __typename?: 'SearchResultsMetadata', itemCount?: number | null, page: number, perPage: number, numPages: number }, items: Array<{ __typename?: 'TechnicalDocument', title: string, text: string, url: string, documentType: string }>, facets: Array<{ __typename?: 'Facet', key: string, numToDisplay?: number | null, isHidden?: boolean | null, isCollapsed?: boolean | null, multiSelect?: boolean | null, options: Array<{ __typename?: 'FacetOptions', value: string, count: number }> }> } };

export type TechnicalDocumentSearchFieldsFragment = { __typename?: 'TechnicalDocument', title: string, text: string, url: string, documentType: string };

export const TechnicalDocumentSearchFieldsFragmentDoc = gql`
    fragment TechnicalDocumentSearchFields on TechnicalDocument {
  title
  text
  url
  documentType
}
    `;
export const ContentDocumentSearchDocument = gql`
    query ContentDocumentSearch($searchTerm: String, $page: Int!, $perPage: Int, $selectedFacets: [FacetInput!], $contentSearchType: ContentSearchType!, $filterSite: String) {
  getContentDocuments(
    input: {searchTerm: $searchTerm, pagination: {page: $page, perPage: $perPage}, facets: $selectedFacets, contentSearchType: $contentSearchType, filterSite: $filterSite}
  ) {
    metadata {
      itemCount
      page
      perPage
      numPages
    }
    items {
      ...TechnicalDocumentSearchFields
    }
    facets {
      key
      numToDisplay
      isHidden
      isCollapsed
      multiSelect
      options {
        value
        count
      }
    }
  }
}
    ${TechnicalDocumentSearchFieldsFragmentDoc}`;
export type ContentDocumentSearchComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<ContentDocumentSearchQuery, ContentDocumentSearchQueryVariables>, 'query'> & ({ variables: ContentDocumentSearchQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const ContentDocumentSearchComponent = (props: ContentDocumentSearchComponentProps) => (
      <ApolloReactComponents.Query<ContentDocumentSearchQuery, ContentDocumentSearchQueryVariables> query={ContentDocumentSearchDocument} {...props} />
    );
    

/**
 * __useContentDocumentSearchQuery__
 *
 * To run a query within a React component, call `useContentDocumentSearchQuery` and pass it any options that fit your needs.
 * When your component renders, `useContentDocumentSearchQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useContentDocumentSearchQuery({
 *   variables: {
 *      searchTerm: // value for 'searchTerm'
 *      page: // value for 'page'
 *      perPage: // value for 'perPage'
 *      selectedFacets: // value for 'selectedFacets'
 *      contentSearchType: // value for 'contentSearchType'
 *      filterSite: // value for 'filterSite'
 *   },
 * });
 */
export function useContentDocumentSearchQuery(baseOptions: Apollo.QueryHookOptions<ContentDocumentSearchQuery, ContentDocumentSearchQueryVariables> & ({ variables: ContentDocumentSearchQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ContentDocumentSearchQuery, ContentDocumentSearchQueryVariables>(ContentDocumentSearchDocument, options);
      }
export function useContentDocumentSearchLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ContentDocumentSearchQuery, ContentDocumentSearchQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ContentDocumentSearchQuery, ContentDocumentSearchQueryVariables>(ContentDocumentSearchDocument, options);
        }
export function useContentDocumentSearchSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ContentDocumentSearchQuery, ContentDocumentSearchQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ContentDocumentSearchQuery, ContentDocumentSearchQueryVariables>(ContentDocumentSearchDocument, options);
        }
export type ContentDocumentSearchQueryHookResult = ReturnType<typeof useContentDocumentSearchQuery>;
export type ContentDocumentSearchLazyQueryHookResult = ReturnType<typeof useContentDocumentSearchLazyQuery>;
export type ContentDocumentSearchSuspenseQueryHookResult = ReturnType<typeof useContentDocumentSearchSuspenseQuery>;
export type ContentDocumentSearchQueryResult = Apollo.QueryResult<ContentDocumentSearchQuery, ContentDocumentSearchQueryVariables>;